<!-- <img sr"../../../../assets/images/merchantReport.pngc=" alt="" width="100%" height="100%"> -->
<div class="card pt-0 mb-5 ">
    <div class="card-header">
        <h4>Documents</h4>
      
      </div>
    <div class="card-body">
      <form (ngSubmit)="onSubmit(orvreport.value)" [formGroup]="orvreport">
        <div>
          <div class="row hidden">
            <div class="col-sm-4">
                <label class="form-label">Merchant Name <span aria-hidden="true" class="symbol required" style="color:red;">*</span> </label>
                <ng-select formControlName="merchantId" (change)="onSelectMerchant($event)"
                  placeholder="Select Merchant">
                  <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.userId">
                    {{merchant.fullName}} ({{merchant.identifier}})
                  </ng-option>
                </ng-select>
  
                <div *ngIf="!mindatadis" class="text-danger mt-1">
                 No Report Found !
                </div>
            </div>
            <!-- <div class="col-sm-2">           
              <button class="btn btn-sm btn-primary mt-4" [disabled]="disablebtn"  type="submit" >Download </button>
              <div  *ngIf="loading" >  
                      <div class="spinner-border" role="status">
                        <span class="sr-only"></span>
                      </div>
              </div>
            </div> -->
           </div>
       
              </div>
       
        </form>
    </div>
    
  <div *ngIf="showhtml">
         <div class="box" >
  
  
              <div class="row">

                <div class="col-lg-12 col-sm-12">
                    <div  class="h-100 p-2">
                        <ul>
                            <li class="m-4"><span class="w-75 d-inline-block">PEP, AML & Sanction Checks </span><button class={{btnpep}}>{{btnvaluepep}}</button> </li>
                            <li class="m-4"><span class="w-75 d-inline-block">OSV Report </span><button class={{osvbtn}}>{{osvvalue}}</button> </li>
                            <li class="m-4"><span class="w-75 d-inline-block">Internal Audit Report </span><button class={{irabtn}}>{{iravalue}}</button> </li>
                            <li class="m-4"><span class="w-75 d-inline-block">Merchant Web Compliance </span><button class={{mcmTncBtn}}>{{mcmTncValue}}</button> </li>
                            <!-- <li class="m-4"><span class="w-75 d-inline-block"> Merchant's Grievance Policy </span><button class={{mcmMGPbtn}}>{{mcmMGPValue}}</button> </li>
                            <li class="m-4"><span class="w-75 d-inline-block">Merchant's Refund Policy </span><button class={{mcmMrpBtn}}>{{mcmMrpValue}}</button> </li>
                            <li class="m-4"><span class="w-75 d-inline-block">PCI-DSS AOC </span><button class={{mcmAOCbtn}}>{{mcmAOCValue}}</button> </li>
                            <li class="m-4"><span class="w-75 d-inline-block">PCI-DSS COC </span><button class={{mcmCOCBtn}}>{{mcmCOCValue}}</button> </li>
                            <li class="m-4"><span class="w-75 d-inline-block">Website VAPT Report</span> <button  class={{mcmVaptbtn}}>{{mcmVaptValue}}</button> </li> -->
                        </ul>
                        <!-- <div class="text-end">
                          <button class="btn btn-primary btn-sm" (click)="downloadManual()" style="margin-right:160px;">Download</button>
                        </div> -->
                  </div>
              </div>
           </div>
     </div>

     <span *ngIf="hidehtml" class="text-align" style="margin-left:44px; font-weight: bold;">KYC Details</span>

     <div *ngFor="let doclist of rowData ">
      <div   *ngIf="hidehtml" class="row">
                <div class="col-lg-12 col-sm-12">
                    <div  class="h-100 p-2">
                        <ul>                
                      <li class="m-4">
                        <span class="w-75 d-inline-block"><strong>{{doclist.docName}}</strong></span>    
                        <!-- <span class="w-75 d-inline-block" *ngIf="doclist.docType!=='pdf'">{{doclist.docType}}</span>     -->
                         <span class="w-75 d-inline-block" >{{doclist.docType}}</span>               
                        <button (click)="onViewBtnClick(doclist.merchantId,doclist.docpath)" class="btn bg-danger-custom" type="button">
                          <i class="feather icon-eye"></i>
                      </button>
                      </li>
                      <!-- <li class="m-4">
                        <span class="w-75 d-inline-block"><strong>{{doclist.docName}}</strong></span>    
                        <span class="w-75 d-inline-block" *ngIf="doclist.docType!=='pdf'">{{doclist.docType}}</span>                   
                        <span class="w-75 d-inline-block">{{(doclist.docType === 'png' ||doclist.docType ===  'pdf'||doclist.docType === 'jpeg' ||doclist.docType ===  'jpg') ? 'CIN Certificate' : doclist.docType}} </span>                       
                         <button (click)="onViewBtnClick(doclist.merchantId,doclist.docpath)" class="btn bg-danger-custom" type="button">
                          <i class="feather icon-eye"></i>
                      </button>
                      </li> -->

                     
                      
                      <!-- <app-modal >
                        <iframe width="100%" height="100%"  [src]="image"></iframe>
                      
                        <img width="100%" alt="" [src]="image"/>                      
                      </app-modal>  -->
                       <!-- <img width="100%" alt="" [src]="image"/> -->
                      </ul>                       
                  </div>
              </div>
   </div>
     </div>
</div>
     <!-- <app-modal >
      <iframe width="100%" height="100%"  [src]="image"></iframe>
      <img width="100%" src={{image}}>  
      <img width="100%" alt="" [src]="image"/>                      
    </app-modal>  -->
     
      <!-- <iframe width="100%" height="100%"  [src]="image"></iframe> -->
     <!-- <div class="text-end">
      <button class="btn btn-primary btn-sm" (click)="downloadManual()" style="margin-right:160px;">Download</button>
    </div>     -->
    </div>


    <app-modal #modalbloked [modalConfig]="modalConfigBlocked">
      <!--  body of the modal  -->
      <img  *ngIf="!pdfvalue" width="100%" src={{image}}> 
      
        <pdf-viewer *ngIf="pdfvalue"
        [src]="image"
        [rotation]="0"
        [original-size]="false"
        [show-all]="true"
        [fit-to-page]="false"
        [zoom]="1"
        [zoom-scale]="'page-width'"
        [stick-to-page]="false"
        [render-text]="true"
        [external-link-target]="'blank'"
        [autoresize]="true"
        [show-borders]="false"
        class="viewer"
        style="height: 80vh; width: 100%; display: block; overflow: auto;"
      >
    </pdf-viewer>
     

 


    
      <!-- <pdf-viewer [src]="pdfSrc"  [render-text]="true"style="display: block;"></pdf-viewer> -->
      <!-- <iframe id="ifrm" style="width: 100%; height: 100%;"></iframe> -->

      <!-- <embed src="C:\Users\Deepak\Downloads\1006.4558.pdf" frameborder="0" width="100%" height="400px"> -->
    </app-modal>

    
  
    
  
   
  
  
